import BaseService from "../../services/base_service"

const paymentsService = new BaseService(
  process.env.VUE_APP_MS_VIRTUALPOS_URL + '/api',
  process.env.VUE_APP_MS_VIRTUALPOS_API_KEY,
  'Authentication'
)

export const state = {
  payments: {
    items: [
    ],
    total_items: 0,
    total_pages: 1,
  },
}

export const getters = {
  payments: (state) => state.payments,
}

export const mutations = {
  SET_PAYMENTS(state, payload) {
    state.payments = {
      items: payload.items.map(item => {
        let rutPayment = item.rut.replace(/C$/, '')
        return {
          id: item.id,
          code: item.folio_number,
          issueDate: item.initial_date,
          dueDate: item.due_date,
          amount: item.total,
          business_name: item.name,
          csiAllowed: mapCsiAllowed(item.project && item.project.csiAllowed),
          status: item.is_paid,
          project: item.project ? item.project.name : '-',
          rut: rutPayment,
        }
      }),
      total_items: payload.total,
      total_pages: payload.number_of_pages,
    }
  },
}

export function mapCsiAllowed(value) {
  if (value == null || value === '') return 'No'
  const normalized = String(value).trim().toUpperCase()
  const isTrue = normalized === 'T' || normalized === 'TRUE' || normalized === '1' || normalized === 'S' || normalized === 'SÍ'
  return isTrue ? 'Sí' : 'No'
}

export const actions = {
  async syncPayments({_}, payload = {}) {
    try {
      const resp = (await paymentsService.post(`/invoices/sync_invoices`, payload))
      return resp
    } catch (error) {
      return error
    }
  },
  async getAllPayments({ commit }, payload = {}) {
    try {
      const resp = (await paymentsService.get(`/invoices/get_invoices`, payload))
      if(!payload.export){
        commit('SET_PAYMENTS', resp.data)
        return resp.data
      }
      return resp
    } catch (error) {
      return error
    }
  },
  async exportPayments({ commit }, payload = {}) {
    try {
      const resp = (await paymentsService.get(`/payments/pending/export`, payload, 'blob')).data
      return resp
    } catch (error) {
      return error
    }
  },
}
